import { Link } from 'react-router-dom';
import { BRAND } from '../../data/constants.js';

const col = (title, links) => (
  <div className="ft-col" key={title}>
    <h4>{title}</h4>
    <ul>{links.map(([l, h]) => <li key={l}><Link to={h}>{l}</Link></li>)}</ul>
  </div>
);

export default function Footer() {
  return (
    <footer className="ft">
      <div className="container ft-in">
        <div className="ft-brand">
          <span className="brand-mark ft-mark">Abriola</span>
          <div className="ft-sub">Propiedades · Quilmes</div>
          <p className="ft-tag">Más de {BRAND.years} años de trayectoria en el mercado inmobiliario de Quilmes y Zona Sur. Honestidad, transparencia y trato personalizado.</p>
          <div className="ft-contact">
            <a href={`https://wa.me/${BRAND.waVentas}`} className="ft-cta" target="_blank" rel="noopener">💬 Ventas {BRAND.phoneVentas}</a>
            <a href={`https://wa.me/${BRAND.waAlquileres}`} className="ft-cta" target="_blank" rel="noopener">💬 Alquileres {BRAND.phoneAlquileres}</a>
            <span className="ft-line">📍 {BRAND.address}</span>
            <a href={`mailto:${BRAND.email}`} className="ft-line">✉ {BRAND.email}</a>
          </div>
          <div className="ft-soc">
            <a href={BRAND.instagram} target="_blank" rel="noopener" aria-label="Instagram">IG</a>
            <a href={BRAND.facebook}  target="_blank" rel="noopener" aria-label="Facebook">FB</a>
          </div>
        </div>
        {col('Operaciones', [['Venta','/buscar?op=venta'],['Alquiler','/buscar?op=alquiler'],['Emprendimientos','/buscar?op=venta&dev=1'],['Tasación','/vender?modo=tasacion']])}
        {col('Propiedades', [['Departamentos','/buscar?op=venta&tipo=departamento'],['Casas','/buscar?op=venta&tipo=casa'],['Terrenos','/buscar?op=venta&tipo=terreno'],['Locales','/buscar?op=venta&tipo=local'],['Galpones','/buscar?op=venta&tipo=galpon']])}
        {col('Abriola', [['Quiénes somos','/nosotros'],['Vender mi propiedad','/vender'],['Contacto','/contacto'],['Favoritos','/favoritos']])}
      </div>
      <div className="container ft-colegio">
        <span className="ft-col-label">Asociados con</span>
        <span className="ft-col-name">🛡 {BRAND.colegio}</span>
      </div>
      <div className="container ft-disclaimer">
        Todas las medidas son meramente orientativas; las exactas serán las del título de propiedad de cada inmueble. Las fotos, imágenes y videos son ilustrativos y no contractuales. Los precios son orientativos y no contractuales.
      </div>
      <div className="container ft-bottom">
        <span>© {new Date().getFullYear()} Abriola Propiedades · Quilmes, Buenos Aires</span>
        <div className="ft-legal">
          <Link to="/">Privacidad</Link><Link to="/">Términos</Link>
        </div>
      </div>
    </footer>
  );
}
